function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

var close = {
  "id": "close",
  "symbol": "<symbol id=\"close\" viewBox=\"0 0 16 16\" style=\"fill: currentColor\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.87879 8.00011L0.939453 3.06077L3.06077 0.939453L8.00011 5.87879L12.9395 0.939453L15.0608 3.06077L10.1214 8.00011L15.0608 12.9395L12.9395 15.0608L8.00011 10.1214L3.06077 15.0608L0.939453 12.9395L5.87879 8.00011Z\" /></symbol>"
};

export { close };
